// Turkse teksten van de to-do's op het bord (zie todo.nl.ts).
export const todoTr = {
    title: 'Yapılacaklar',
    from: '{name} ekledi',
    all: 'Tüm yapılacaklar ({count})',
    sheetTitle: '{name} için yapılacaklar',
    due: 'en geç {date}',
    empty: 'Yapılacak bir şey kalmadı',
    done: 'Bitti',
    everyone: 'Tümü',
    filterOpen: 'Açık',
    filterDone: 'Bitti',
    filterAll: 'Tümü',
    doneSection: 'Bitti ({n})',
    doneBy: '{name} · {when}',
    forWho: '{name} için',
    created: '{date} tarihinde eklendi',
    important: 'Önemli',
    add: 'Yapılacak ekle',
    noDescription: 'Açıklama yok',
    emptyDone: 'Bu hafta henüz bir şey bitmedi',
    assign: 'Şuna ata…',
    assignTitle: 'Şuna ata',
    assignSave: 'Ata',
    assigned: 'Atandı',
    assignFailed: 'Atanamadı',
};
//# sourceMappingURL=todo.tr.js.map